import text from '../text.json'
import Input from '../../../components/core/input'
import {SimpleBlueButton} from '../../../components/core/button'
import ButtonLoader from '../../../components/core/button/ButtonLoader'
import {FieldArray, Formik} from 'formik'
import {useMemo, useState} from 'react'
import {useDispatch} from 'react-redux'
import integrationTypes from '../../../data/integrationTypes.json'
import CustomSelect from '../../../components/core/customSelect'
import {StatuspageIoIcon, StatusIoIcon} from '../../../icons'
import {statusIoSchema, statuspageIoSchema} from '../../../utils/validation'
import {editIntegration, getIntegrations} from '../../../stores/integration'
import {trimStringValues} from '../../../utils/text'

const integrationTypeElement = (value, label, isDisabled, icon) => {
    return {value, label, isDisabled, icon}
}

const fieldNames = {
    type: 'type'
}

const statuspageIoInputs =   [
    {
        name:'name',
        type: 'text',
        placeholder:'Name',
        infoText: text.name_info,
        disabled: false
    },
    {
        name:'api_key',
        type: 'text',
        placeholder:'API Key',
        infoText: text.api_key_info.replace(':value', text.statuspageIo),
        disabled: false
    },
    {
        name:'page_id',
        type: 'text',
        placeholder:'Page ID',
        infoText: text.page_id_info.replace(':value', text.statuspageIo),
        disabled: true
    }
]

const statusIoInputs =   [
    {
        name:'name',
        type: 'text',
        placeholder:'Name',
        infoText: text.name_info,
        disabled: false
    },
    {
        name:'api_id',
        type: 'text',
        placeholder:'API ID',
        infoText: text.api_id_info.replace(':value', text.statusIo),
        disabled: false
    },
    {
        name:'api_key',
        type: 'text',
        placeholder:'API Key',
        infoText: text.api_key_info.replace(':value', text.statusIo),
        disabled: false
    },
    {
        name:'page_id',
        type: 'text',
        placeholder:'Page ID',
        infoText: text.page_id_info.replace(':value', text.statusIo),
        disabled: true
    }
]

const INTEGRATION_LOOKUP = {
    [integrationTypes.types.statuspageIo]: statuspageIoInputs,
    [integrationTypes.types.statusIo]: statusIoInputs
}

const VALIDATION_LOOKUP = {
    [integrationTypes.types.statuspageIo]: statuspageIoSchema,
    [integrationTypes.types.statusIo]: statusIoSchema
}

const EditIntegration = ({resetChecked, closePopup, data}) => {
    const isIntegrationDisabled = false
    const integrationTypeOptions = useMemo(() => {
        return [
            integrationTypeElement(integrationTypes.types.statuspageIo, 'Statuspage.Io', isIntegrationDisabled, <StatuspageIoIcon />),
            integrationTypeElement(integrationTypes.types.statusIo, 'Status.io', isIntegrationDisabled, <StatusIoIcon />)
        ]
    }, [isIntegrationDisabled])
    const dispatch = useDispatch()
    const [active, setActive] = useState(null)
    const [selectedIntegration, setSelectedIntegration] = useState(integrationTypeOptions.find(item => item.value === data?.type) || null)

    const initialFormValues = {
        type: integrationTypeOptions.find(item => item?.value === data?.type),
        name: data?.name,
        api_id: '',
        api_key: '',
        page_id: data?.provider_id

    }

    const handleInfo = (index, state) => {
        state ? setActive(index) : setActive(null)
    }

    const updateIntegration = async(values, {setFieldError, resetForm}) => {
        const requestData = {
            name: values.name,
            api_key: values.api_key,
            api_id: values.api_id
        }
        const success = await dispatch(editIntegration(trimStringValues(requestData), setFieldError, resetForm, data?.provider_id))
        if (success) {
            dispatch(getIntegrations(false))
            resetChecked()
            closePopup()
        }
        return true
    }

    const checkSchema = (name, data, setFieldValue, setErrors) => {
        setFieldValue(name, data)
        setSelectedIntegration(data)
        setErrors({})
    }

    return (
        <Formik initialValues={initialFormValues}
            enableReinitialize={true}
            onSubmit={updateIntegration}
            validationSchema={VALIDATION_LOOKUP[selectedIntegration.value]}
            validateOnBlur={false}
            validateOnChange={false}>
            {({values, errors, handleSubmit, setFieldValue, handleChange, isSubmitting, setErrors}) => {
                return  (
                    <form onSubmit={handleSubmit} className="modal-body">
                        <CustomSelect
                            placeholder={text.type}
                            onChange={(name, data) => checkSchema(name, data, setFieldValue, setErrors)}
                            infoText={text.type_info}
                            name={fieldNames.type}
                            value={values.type}
                            options={integrationTypeOptions}
                            defaultFirst={true}
                            checkboxClassName="multiselect"
                            activeInfo={active === fieldNames.type}
                            handleInfo={(state) => handleInfo(fieldNames.type, state)}
                            error={errors.type}
                            isDisabled={true}
                        />
                        <FieldArray name={fieldNames.integrationValues}>
                            {
                                () => INTEGRATION_LOOKUP[values.type?.value]?.map((item, index) => {
                                    return values.type && <Input
                                        key={index + fieldNames.type}
                                        type={item.type}
                                        infoText={item.infoText}
                                        placeholder={item.placeholder}
                                        name={item.name}
                                        value={values[item.name]}
                                        onChange={e => {
                                            handleChange(e)
                                            setFieldValue(item.name, e.target.value)
                                        }}
                                        activeInfo={active === item.name}
                                        handleInfo={(state) => handleInfo(item.name, state)}
                                        error={errors[item.name]}
                                        inputIsDisabled={item.disabled}
                                    />
                                }
                                )
                            }
                        </FieldArray>
                        <SimpleBlueButton
                            type="submit"
                            disabled={isSubmitting}
                        >
                            {isSubmitting && <ButtonLoader/>}
                            {text.submit}
                        </SimpleBlueButton>
                    </form>
                )
            }}
        </Formik>
    )
}

export default EditIntegration
